export enum DealsPolicies {
    OFF = "off",
    PLC = "plc",
    PER = "per",
}
